import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { filterProps } from 'helpers/utils'
import Button from '../Button/Button'
import Icon from '../Icon/Icon'

const FilterButton = ({ title, ...props }) =>
  <CustomButton { ...props } filter full data-at-filter-button>
    <Icon asset="icon-filter-white" margin="-3px 10px 0 0" />
    { title }
  </CustomButton>

export default FilterButton

FilterButton.propTypes = {
  title: PropTypes.string
}

const CustomButton = styled(props => <Button { ...filterProps(props, ['filter']) } />)`
  padding: 6px 24px;
  line-height: 26px;
`
